import { Component, OnDestroy, OnInit } from '@angular/core';
import { DocRouteService } from './doc-route.service';
@Component({
  selector: 'app-docs',
  templateUrl: './docs.component.html',
  styleUrls: ['./docs.component.scss']
})
export class DocsComponent implements OnInit {
  currentUrl = '/assets/docs/devportal/RNPA Auto/index.html'

  constructor(
    private _docRoute: DocRouteService
  ) { }

  ngOnInit(): void {
    this._docRoute.urlDocsObservable.subscribe((res) => {
      this.currentUrl = res
      const iframeEl = document.getElementById("iFrameDevPortal")
      if (iframeEl) {
        iframeEl.setAttribute("src", this.currentUrl)
      }
    })
  }

}
